import React from 'react';
import { connect } from 'react-redux'

import AssistTicket from './manageTickets/AssistTicket';
import CompletePackageTicket from './manageTickets/CompletePackageTicket';

import chillOut from '../../../assets/img/chillOut.svg';
import panda from '../../../assets/img/panda.svg';

class ManageTickets extends React.Component {
    render(){
        let { authenticatedUser, tickets, sessions } = this.props
        const { ticket, customer } = this.props;
    
        //  first we handle tickets that were already called by my userId. This could be caused by
        // an agent that logged out or browser closed before the ticket was closed
        let priorityTickets = tickets.filter( data => 
            ( Number(data.status) === 1 && data.manage.userId === authenticatedUser.id)
        )

        // we check for priorityTickets
        // we will add this later
        
        // if there are no open tickets
        if( !priorityTickets.length ){
            // find tickets that are not served yet
            priorityTickets = tickets.filter( data => 
                (   
                    // get tickets that are not called yet AND
                    ( Number(data.status) === 0 
                        && (
                            //  are included in my services
                            //  first make sure it is not allocated to something else
                            (
                                data.manage != null
                                ?   data.manage.userId == null && data.manage.supportDeskId == null
                                    ?   ( authenticatedUser.services.includes(data.serviceId) )
                                    : 1 === 2 // used to exit check
                                : ( authenticatedUser.services.includes(data.serviceId) )
                            )

                            // or were sent to my userId
                            || ( 
                                data.manage != null 
                                ?   data.manage.userId!= null
                                    ?   data.manage.userId === authenticatedUser.id
                                    :   1 === 2 // used to exit check
                                :   1 === 2 // used to exit check
                            )

                            // or were sent to my supportDesk
                            || ( 
                                // get the supportDeskId my userId is logged in with and compare with ticket supportDeskId
                                data.manage != null 
                                ?   data.manage.supportDeskId != null
                                    ?   ( 
                                            data.manage.supportDeskId === sessions
                                                .find( session => 
                                                    session.userId === authenticatedUser.id 
                                                ).supportDeskId 
                                        )
                                    :   1 === 2 // used to exit check
                                :   1 === 2 // used to exit check
                            )
                        )
                    )
                       
                )
            )

        }

        let bgStyle = !priorityTickets.length ? {background:'#fff'} : {}
        return (
            <div className="calling-group-wraper" style={bgStyle}>
            {
                priorityTickets.length
                    ?   (
                            <>
                                <div className="titleBlock group">
                                    <h4>Package Pickups</h4>
                                </div>
                                <div className="calling-group">
                                    <div className="home-left-content2-item-wraper" >
                                        <AssistTicket ticket={ticket} />
                                        <CompletePackageTicket ticket={ticket} customer={customer} />
                                    </div>
                                </div>
                            </>
                        )
                    :   ( 
                        <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', padding: '28px 0 23px'}}>
                            <img src={chillOut} alt="relax" />
                            <img style={{marginTop:'20px'}} src={panda} alt="Panda with laptop" />
                        </div>
                    )
            
            }
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { auth, tickets, sessions } = state
    return {
        authenticatedUser: auth.authenticatedUser,
        activeTicketId: tickets.activeTicketId,
        tickets: tickets.tickets,
        sessions: sessions.sessions
    }
}

export default connect(mapStateToProps, {})(ManageTickets);

